import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Box,
  Typography,
  Paper
} from "@mui/material";
import ReplayIcon from "@mui/icons-material/Replay";
import CloseIcon from "@mui/icons-material/Close";
import MedicationIcon from "@mui/icons-material/Medication";

const ChronicMedicationDialog = ({ open, onClose, meds }) => {
  return (
    <Dialog
      open={open}
      
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
          overflow: "hidden"
        }
      }}
    >
      <DialogTitle
        sx={{
          background: "linear-gradient(135deg, #54d48eff 0%, #3f2f50ff 100%)",
          color: "white",
          fontWeight: 700,
          fontSize: "1.5rem",
          py: 3,
          px: 3,
          position: "relative"
        }}
      >
        Chronic Medication 
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "white",
            "&:hover": {
              backgroundColor: "rgba(255, 255, 255, 0.2)"
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 4, backgroundColor: "#fafafa" }}>
        {meds.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 10,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2
            }}
          >
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: "50%",
                backgroundColor: "#f5f5f5",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1
              }}
            >
              <MedicationIcon sx={{ fontSize: 40, color: "#bdbdbd" }} />
            </Box>
            <Typography variant="h6" color="text.secondary" fontWeight={500}>
              No chronic medication saved for this patient.
            </Typography>
          </Box>
        ) : (
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              border: "1px solid #e0e0e0"
            }}
          >
            <Table
              sx={{
                "& .MuiTableCell-head": {
                  background: "linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%)",
                  fontWeight: 700,
                  color: "#424242",
                  fontSize: "0.875rem",
                  borderBottom: "2px solid #bdbdbd",
                  py: 2
                },
                "& .MuiTableBody-root .MuiTableRow-root": {
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#ede7f6",
                    transform: "scale(1.001)"
                  }
                },
                "& .MuiTableCell-body": {
                  fontSize: "0.875rem",
                  py: 2
                }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Drug</TableCell>
                  <TableCell>Dose</TableCell>
                  <TableCell>Frequency</TableCell>
                  <TableCell>Days</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Route</TableCell>
                  <TableCell>Doctor</TableCell>
                 
                </TableRow>
              </TableHead>

              <TableBody>
                {meds.map((m, idx) => (
                  <TableRow key={idx}>
                    <TableCell>
                      <Typography
                        variant="body2"
                        sx={{ fontWeight: 600, color: "#1a237e" }}
                      >
                        {m.medication}
                      </Typography>
                    </TableCell>
                    <TableCell>{m.dose}</TableCell>
                    <TableCell>{m.freq}</TableCell>
                    <TableCell>{m.days}</TableCell>
                    <TableCell>{m.qty}</TableCell>
                    <TableCell>{m.route}</TableCell>
                    <TableCell>{m.doctor}</TableCell>
                   
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ChronicMedicationDialog;